// Placeholder types
export enum TenantIconNameEnum {
  tenantLogo = "tenantLogo",
}
export enum TenantImageNameEnum {}
